import { Controller } from '@hotwired/stimulus';
import { debounce } from '@inked/utilities';

export class AutoSubmitController extends Controller {
  static values = {
    delay: {
      type: Number,
      default: 150,
    },
  };

  submit() {
    if (this.delayValue > 0) {
      debounce(() => this.element.requestSubmit(), this.delayValue)();

      return;
    }

    this.element.requestSubmit();
  }
}
